import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '현대적인 감시 카메라 시스템을 이야기할 때 NVR(Network Video Recorder)을 빼놓을 수 없습니다. NVR은 네트워크를 통해 영상을 기록하는 장치로, 아날로그 카메라만 지원하는 DVR과 달리 IP 카메라와 직접 연동하여 선명한 화질과 유연한 확장성을 제공합니다. 이번 글에서 ORBRO와 함께 NVR이 무엇인지, 그리고 NVR이 모든 보안 감시 솔루션에서 최적의 선택이 되는 이유를 알아보세요.',
  keywords: 'NVR, 감시 카메라 시스템, NVR IP 카메라, 보안 감시 솔루션',
  ogSite: 'NVR, 네트워크 비디오 레코더: 보안 감시 시스템의 핵심',
  title: 'NVR, 네트워크 비디오 레코더: 보안 감시 시스템의 핵심',
  ogUrl: 'https://orbro.io/blog/what-is-nvr',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_HTpXKLDbaS9Y_3ybAa3BKgvhT2Vm5kdBC0BtJct0y3JyK3JvT_iM1mR4lKRVxAzUfBxk21JfPJzcS8j3Lo3nt6dhDt4F35VYjBxD1C3DJoC56VeYemJ20gk44KQJ3TT16PXeCTKFmR76jXxN9ea0XSLPM5XJHGvWtEglRxVapC7yELeFhwm-ERF1eJ2QFIEVjNp_CXXSRM7h_3RYLFmgpiEWg4pii5k_XC9paUPeeuoM75nCKTrORwZZe4oRzoj-d7EWv5WQHzsUOlRmsqeCcx9Xzf-KMRwidU8dcvopnkWqp63Hf5IOrH4MKHcVdyrCYsZzMhlvztRisAruBaekk9m7nWd2BYTtjC958u_ImNxoPqkt9eVzHMHHAj76z42JxngD5t-pnPDrr5dzU7qIKZQnhKcbyOZ2PL3nDJRQrMl57-W-lkUrBTrJYpe7Hcj2KKJtYuJycWc5evrf2lYQPV8eiKwKG2MYdGJf9_sqZnm3KOmUICmglImXJ7tPH52bTm7oPEBQFDDcbyzpHbo1EXEOBDZHgB1hftPhEGU95wneBG97Mzfr3vHdVyfc9reqAyziq3lQdlYVNxjzHEFmE9ed4QZ5eJqkTWTUwOEHnCtwoweO3lLPGDOxoa0zBQRlZlzBlc37t3CPP9fHrEJsb556EGUbMZk9sEmBjJj3-UcaTiiNEFodDcyHhrnplhIgo9-3LVXOJx2KWsIYd3mG4hCpJWv5DOTPetaZQvRd4xobK2OJMl4JhxkmEEx98f-d7Pnglu7mojlCE_eqHRA_zyR0zlBa2GIU6KVTu2WnqyANAMl0PWJfIM7Sacligzr6wFhxkuJzu3YH3zrG0qg8MnBTgmsoHIHCepmn0lY3l9iGiLpKMdIRdOW4-x0edq3ewcNjImQUtiGltkmyIkqOeLMv6b1OJUk-12AaADV4dtNEJBDx4xRIiKcFBY0j2CkzKLzp90xAfKNOZpxOpsnw8lAMFCOixc16jZpnLpUpaRu1hUQO0mnH9WSHsd9LB7Bh7yAzIcGr1pkHMiFdzO73y3NRJTuDqYluwJzrRBjDogKPoDMMi1DpjarQwtqI2jQTxWyVRWk_5eEc5-Z2tfzHVC6el3vN5jWBzqeeFmRC8IrraBnBj-0vIyBVQ6nQAy9JhE7kI4DT22VIA8AYvB6zNZiblln-r1QYOlCbVz4ujGHyVD0sUE7nPBxQQwsp6IKlu03Ximb-nY_zNAMyrg3O8BFEbjDV7nDqX9fAhnZV_s20cLEaWd_NGiS8ejTw8i_OVFVXhZbmeAzBCyCWd_JqGTXI9IJ8p3D5eMIINuGZlPOBglJTTb8tAKTSOrJSre8LnZ8hN0VeZ7v_3DaaMIQRgjInhQtjrwSUCbZpZ2hIEFb_vMnjmW26n7igMfuXpxZxAP5KV2G6Z270GqM8GfQ1O-V7DswIFfEBdzrz5r61LylktIdMNfVYcj7cejnbLhp8HD4I4TC12_bWU0Mrkl75X3-8cWruQG5e7p0L9Cvh8jkdX5cyDKEJyx5MnOTm49UMTt1evvd46PMbuyvi6xNMsSJEwP88U4XbFGRAIu08Z_bR_KRCijEuVcj19JT18N-SC6vpoNzmGEaRjHo8vazRBZh7nKVXxcD9buag=w1432-h1440?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-09',
  tag1: '#NVR',
  tag2: '#감시카메라시스템',
  tag3: '#NVRIP카메라',
  tag4: '#보안감시솔루션',
  text: [
    {
      head: '',
      subHead: '',
      desc: '현대적인 감시 카메라 시스템을 이야기할 때 NVR(Network Video Recorder)을 빼놓을 수 없습니다. NVR은 네트워크를 통해 영상을 기록하는 장치로, 아날로그 카메라만 지원하는 DVR과 달리 IP 카메라와 직접 연동하여 선명한 화질과 유연한 확장성을 제공합니다. 이번 글에서 ORBRO와 함께 NVR이 무엇인지, 그리고 NVR이 모든 보안 감시 솔루션에서 최적의 선택이 되는 이유를 알아보세요.',
      dot: ''
    },
    {
      head: '1. NVR이란?',
      subHead: '',
      desc: 'NVR(Network Video Recorder)은 네트워크 비디오 레코더로, IP 카메라에서 촬영된 비디오를 인터넷 연결을 통해 저장하고 관리하는 장치입니다. 동축 케이블을 통해 아날로그 신호를 전송하는 대신, NVR은 LAN 또는 인터넷 네트워크를 통해 IP 카메라에서 디지털 비디오를 수신하고 인코딩합니다. 이를 통해 더 높은 화질을 제공하며, Full HD, 4K 해상도를 지원하고 중앙 집중식 관리를 효율적으로 수행할 수 있습니다.\n\nNVR의 구성 요소\n\nPoE 포트(Power over Ethernet): 단일 네트워크 케이블로 카메라에 전원과 데이터를 동시에 공급합니다.\n\n저장용 하드 디스크: 연속 녹화 또는 이벤트 기반 녹화를 최적화합니다.\n\nLAN/WAN 네트워크 포트: NVR을 내부 네트워크에 연결하고 원격 액세스를 지원합니다.\n\n관리 인터페이스: 소프트웨어 또는 웹 UI를 통해 실시간 스트리밍, 재생, 시스템 설정을 관리할 수 있습니다.',
      dot: ''
    },
    {
      head: '2. NVR의 작동 방식',
      subHead: '',
      desc: 'IP 카메라 연결: 카메라는 IP 주소를 가지며, PoE 지원 스위치에 연결됩니다.\n\n녹화 및 인코딩: NVR은 디지털 비디오 스트림을 수신하고 H.264/H.265 \n형식으로 인코딩하여 대역폭을 절약합니다.\n\n저장 및 관리: 비디오는 하드 디스크에 저장되며, 일정에 따라, 움직임 감지 시, 또는 경고 발생 시 녹화하도록 설정할 수 있습니다.\n\n보기 및 분석: 사용자는 소프트웨어 또는 모바일 앱을 통해 실시간 보기, 재생, 파일 내보내기를 할 수 있습니다.',
      dot: ''
    },
    {
      head: '3. NVR의 감시 카메라 시스템 내 장점',
      subHead: '',
      desc: '뛰어난 화질\n고해상도 지원: Full HD, 4K, 8K 옵션을 제공합니다.\n최신 인코딩: H.265를 통해 대역폭을 절약하고 저장 용량을 줄입니다.\n\n확장성과 유연성\nPoE 연결: 하나의 네트워크 케이블로 전원과 데이터를 전송하여 전선 비용을 절감합니다.\n중앙 집중식 관리: 수십, 심지어 수백 대의 IP 카메라를 하나 이상의 NVR에 연결하여 쉽게 확장할 수 있습니다.\n\n높은 보안성\n데이터 암호화: 네트워크를 통해 전송되는 비디오는 SSL/TLS와 같은 보안 프로토콜로 보호됩니다.\n접근 권한 설정: 각 사용자 계정은 허가된 카메라 또는 영역만 볼 수 있습니다.\n\n지능형 기능\n움직임 감지 및 경고: 움직임이 감지되거나 금지 구역에 침입 시 이메일 또는 푸시 알림을 보냅니다.\nAI 통합: 얼굴 인식, 사람 수 세기, 행동 분석 기능을 제공합니다.\n\n운영 비용 절감\n케이블 및 설치 비용 감소: PoE와 중앙 집중식 관리를 통해 인력과 자재를 절약합니다.\n저장 최적화: 스마트 인코딩과 녹화 메커니즘으로 하드 디스크를 효율적으로 사용하며 중요한 데이터를 보장합니다.',
      dot: ''
    },
    {
      head: '4. 실제 응용 사례',
      subHead: '',
      desc: '사무실 건물: 복도, 출입구, 회의실 감시\n\n공장 및 제조 시설: 생산 라인, 창고 모니터링 및 이상 상황 경고\n\n주거 지역 및 아파트: 출입구, 주차장, 놀이터 감시\n\n교통: 교차로 모니터링, 위반 기록, 교통 흐름 분석',
      dot: ''
    },
    {
      head: '5. 결론',
      subHead: '',
      desc: '높은 화질의 녹화, 유연한 확장성, 지능형 통합 기능을 갖춘 NVR은 모든 감시 카메라 시스템에서 최고의 선택으로 자리 잡고 있습니다. 소규모 기업이든 대기업이든, NVR을 도입하면 보안을 강화하고 비용을 최적화하며 효율적인 중앙 관리를 실현할 수 있습니다. 다음 보안 감시 솔루션으로 NVR을 고려해보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
